import sort from 'array-sort';

const getAlerts = (returnArr = true) => {

  return new Promise((resolve, reject) => {

    window.apiRequest('get',  '/alerts/all').then(r => {

      if(r.type === 'success') {

        if(returnArr) {

          resolve(sort(r.data, 'alert_name'));

        } else {

          const alerts = {};

          r.data.forEach(alert => {
            alerts[alert.id] = alert;
          });

          resolve(alerts);

        }

      } else {
        reject();
      }

    });

  });

};

export default getAlerts;
